import { useT, useOpenpeeps, useSetPageHeader } from '../../index';
import {
  Feed,
  useDefaultVisibility,
  useNewNotePlusButton,
  useServerInfo,
  PluginSlot,
} from '../../components';

export function FeedsLocal() {
  const t = useT();
  const { openpeepsApi } = useOpenpeeps();
  const serverInfo = useServerInfo();
  const visibility = useDefaultVisibility();

  useNewNotePlusButton({ visibility });

  const query = openpeepsApi.useLocalFeed();
  const pinnedPostId = serverInfo.communityConfig?.content?.pinnedPost;
  const isEmpty =
    query.data?.pages.every((page) => page.length === 0) && !pinnedPostId;

  useSetPageHeader(
    t('navigation.community', { defaultValue: 'Community' }),
    undefined,
    'feeds-community-heading',
  );

  return (
    <>
      <PluginSlot name="plugins.header" className="p-4 pb-0" />
      {isEmpty ? (
        <PluginSlot
          name="plugins.feeds.local.empty"
          props={{ locus: 'plugins.feeds.local.empty' }}
          className="p-4 pb-0"
        />
      ) : null}
      <Feed query={query} pinnedPostId={pinnedPostId ?? undefined} />
    </>
  );
}
